var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftArrow1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12733_2674)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5 45C34.9264 45 45 34.9264 45 22.5C45 10.0736 34.9264 0 22.5 0C10.0736 0 0 10.0736 0 22.5C0 34.9264 10.0736 45 22.5 45Z",
    fill: "#F16062"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0493 17.0239L27.9858 17.9614L28.0913 18.0668L27.9858 18.1733L19.5659 26.5991H23.2241V28.2231H16.7866V21.7866H18.4116V25.4428L26.8374 17.0239L26.9429 16.9184L27.0493 17.0239Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5029 8.84961C26.1461 8.84961 29.5745 10.2736 32.1533 12.8457H32.1543C34.7333 15.4247 36.1504 18.8539 36.1504 22.4971C36.1502 30.0255 30.0255 36.1502 22.4971 36.1504C18.8539 36.1504 15.4247 34.7333 12.8457 32.1543C10.2667 29.5753 8.84961 26.1461 8.84961 22.5029C8.84977 14.9745 14.9745 8.84977 22.5029 8.84961ZM22.5029 10.4805C15.8764 10.4806 10.4806 15.8764 10.4805 22.5029C10.4805 25.7179 11.7301 28.735 14.001 31.0059C16.2717 33.2765 19.2882 34.5263 22.5029 34.5264C29.1297 34.5264 34.5264 29.1297 34.5264 22.5029C34.5263 19.2882 33.2765 16.2717 31.0059 14.001C28.735 11.7301 25.7179 10.4805 22.5029 10.4805Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12733_2674"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow1);
export default __webpack_public_path__ + "static/media/left-arrow 1.3b415a168dae9aa00e97d9222c8d4015.svg";
export { ForwardRef as ReactComponent };